<template>
<div id="home">
  <my-header></my-header>
  <div class="pd20">
    <loading v-if="loading" :text="'Please wait'|translate"></loading>
    <div v-if="group">
      <h3 class="mt0">{{'Group Profile'|translate}}</h3>
      
      <div class="row mt20" v-if="!loading" >
        <div class="col-md-6">
          <label class="mt10">Tên:</label>
          <p>{{group.name}}</p>
          
          <p v-if="!group.name">{{'No information'|translate}}</p>
          <div v-if="group.group">
            <label class="mt10">{{'Member of group'|translate}}:</label> 
            <p>
            {{group.group.name}}</p></div>        
          <label class="mt10">Điện thoại:</label>
          <p v-if="group.phone"><a :href="'phone:'+group.phone">{{group.phone}}</a></p>
          <p v-if="!group.phone">{{'No information'|translate}}</p>

          
          <div class="mb20"  v-if="group.feature_image">
            <p >
              <label>{{"Feature Image"|translate}}</label>
              
            </p>
            <img :src="group.image" />  
          </div>
          


        </div>
        <!-- end col-md-6 -->
        <div class="col-md-6">
          <label >Mô tả:</label>
          <div class="detail mb20" >
            <p v-if="group.description" v-html="group.description"></p>
            <p v-if="!group.description">{{'No information'|translate}}</p>
          </div>          
          <p class="mt10 mb0"><label>Mã QR:</label></p>

          <qrcode :value="getLink()" tag="img" :options="{ width: size }"></qrcode>
          <p><small>Bạn có thể dùng mã code này để chia sẻ link</small</p>
            <div v-if="group.province_name">
              <label class="mt10">{{'Address'|translate}}:</label>
              <p class="address" >{{group.commune_name}}, {{group.district_name}}, {{group.province_name}}</p>
            </div>

        </div>
        <!-- end col-md-6 -->
      </div>
    </div>

  </div>
  <!-- end pd20 -->
</div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Loading from '@/components/elements/Loading'

export default {
  name: 'GroupProfile',
  components: {
    MyHeader,
    Loading
  },
  data () {
    return {
      loading: true,
      group:null,
      id: null,
      size:120
    }
  },
  watch: {
    $route(to, from) {
      console.log('from',from)
      console.log('to',to)
      this.loadInfo()
    },
  },
  methods: {
    getLink (){
      return window.location.href
    },
    loadInfo(){
      this.loading = true
      this.profile = null
      let profileId = this.$route.params.profileId
      
      let data = {
        offset: 0,
        limit: 1,
        id: this.id
      };
      
      
      let wating = [Utils.request(this, true, "group").get(`/manage/?${Utils.arrayToRequestParam(data)}`)]
      
      Promise.all(wating).then(values => {
        this.loading = false
        let item = values[0].data.data.list[0]
        console.log('item',item)
        if (item){
          item.image = item.feature_image
            ? item.feature_image.thumb
            : "/static/images/no-photo.jpg";
          this.group = item;  
        }
        
        //this.userProducts = values[1].data.data

      })
    }
  },
  mounted () {
    this.id = this.manage_id = this.$route.params.id;
    this.loadInfo()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Group/GroupProfile.vue